"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manage_terms = void 0;
var qs = require('qs');
exports.manage_terms = function (axios) {
    return {
        getTerms: function (getTermsRequest) {
            var _a = getTermsRequest.params, mallNo = _a.mallNo, termsType = _a.termsType;
            return axios.get('/terms', {
                params: {
                    termsType: termsType,
                    mallNo: mallNo
                },
                paramsSerializer: function (params) {
                    return qs.stringify(params, { arrayFormat: 'repeat' });
                }
            });
        },
        postTerms: function (postTermsRequest) {
            return axios.post('/terms', postTermsRequest.data);
        },
        getTermsStandard: function (getTermsStandardRequest) {
            return axios.get('/terms/standard', getTermsStandardRequest);
        },
        getTermsHistories: function (getTermsHistoriesRequest) {
            return axios.get('/terms/histories', {
                params: getTermsHistoriesRequest.params,
                paramsSerializer: function (params) {
                    return qs.stringify(params, { arrayFormat: 'repeat' });
                },
                headers: { Version: '1.1' },
            });
        },
        deleteTermsByTermsNo: function (_a) {
            var params = _a.params, pathParams = _a.pathParams;
            return axios.delete("/terms/" + pathParams.termsNo + "?mallNo=" + params.mallNo);
        },
        patchTermsByTermsNo: function (request) {
            var _a = request.params, mallNo = _a.mallNo, showInHistory = _a.showInHistory;
            return axios.patch("/terms/" + request.pathParams.termsNo + "?mallNo=" + mallNo + "&showInHistory=" + showInHistory);
        },
        // GET/terms/configurations 약관 설정 조회
        getTermsConfigurations: function (_a) {
            var params = _a.params;
            return axios.get("/terms/configurations?mallNo=" + params.mallNo);
        },
        // PATCH/terms/configurations 약관 설정 수정
        patchTermsConfigurations: function (_a) {
            var data = _a.data;
            return axios.patch('terms/configurations', data);
        },
        getTermsCustom: function (_a) {
            var params = _a.params;
            return axios.get("/terms/custom?mallNo=" + params.mallNo + "&page=" + params.page + "&pageSize=" + params.pageSize);
        },
        postTermsCustom: function (_a) {
            var data = _a.data;
            return axios.post('/terms/custom', data);
        },
        putTermsCustomCustomTermsNo: function (_a) {
            var data = _a.data, pathParams = _a.pathParams;
            return axios.put("/terms/custom/" + pathParams.customTermsNo, data);
        },
        getTermsCustomHistories: function (_a) {
            var params = _a.params;
            return axios.get("/terms/custom/histories?mallNo=" + params.mallNo + "&customTermsNos=" + params.customTermsNos + "&page=" + params.page + "&pageSize=" + params.pageSize + "&isExcludeEnforceOrder=" + params.isExcludeEnforceOrder);
        },
        deleteTermsCustomCustomTermsNo: function (_a) {
            var pathParams = _a.pathParams;
            return axios.delete("/terms/custom/" + pathParams.customTermsNo);
        },
        getTermsTargetTargetNo: function (_a) {
            var params = _a.params, pathParams = _a.pathParams;
            return axios.get("/terms/target/" + pathParams.targetNo + "?categoryType=" + params.categoryType + (params.mallNo ? "&mallNo=" + params.mallNo : ''));
        },
    };
};
